module.exports = __webpack_public_path__ + "img/melvid-cartoes.1fd5372b.png";